import _util from '../../utils/';


const contractManagementService = {
	fetchContractList(params, resolve, reject) {
		_util.request({
			url: '/api/HRContract/Get' ,
            params: params,
			success: resolve,
			error: reject
		})
	},
	fetchContractEmployee(gets, resolve, reject) {
        _util.request({
            url: '/api/HRContract/Get',
            params: gets,
            success: resolve,
            error: reject
        })
    },
	fetchContractDetail(employee_id, resolve, reject) {
		_util.request({
			url: '/api/HRContract/EmployeeGet?employee_id=' + employee_id,
			success: resolve,
			error: reject
		})
	},
	exportContract(resolve, reject) {
		_util.request({
			url: '/api/HRContract/Export',
			success: resolve,
			error: reject
		})		
	},
	initContarctAlert(resolve, reject) {
		_util.request({
			url: '/api/HRAlertSetting/Get',
			success: resolve,
			error: reject
		})
	},
	contractAlert(posts, resolve, reject) {
		_util.request({
			url: '/api/HRAlertSetting/ContractPost',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})		
	},
	deleteContract(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRContract/Delete?id=' + deletes.id,
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		})			
	},
	addContract(posts, resolve, reject) {
		_util.request({
			url: '/api/HRContract/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})		
	},
	editContract(puts, resolve, reject) {
		_util.request({
			url: '/api/HRContract/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})		
	},
	downloadTemplate(resolve, reject) {
        _util.request({
            url: '/api/HRContract/GetImportTemplate',
            success: resolve,
            error: reject
        });
    },
    importContract(posts, resolve, reject) {
        _util.request({
            url: '/api/HRContract/Import',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        })
	},
	
	fetchContractReceiveExpireMembers(posts, resolve, reject) {
		_util.request({
			url: '/api/HRAlertSetting/GetContractReceiveExpireMembers',
			data: posts,
			success: resolve,
			error: reject
		})		
	},
}

export default contractManagementService;


// WEBPACK FOOTER //
// ./src/services/EmployeeManagement/contract-management-service.js